import { Component, Input } from '@angular/core';
import { Subject } from 'rxjs';
import { RightPanelService } from '../../core/services/right-panel.service';
import { TicketService } from '../../core/services/ticket/ticket.service';
import { NotificationsService } from 'angular2-notifications';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { finalize, takeUntil } from 'rxjs/operators';
import { ThreadElementDTO } from '@sb-tools/typescript/models/dto/thread-element.dto';
import { HideContentPartResponseDTO } from '../../core/models/dto/hide-content-part-response.dto';
import { ContentVisibilityModel } from '../../core/models/content-visibility-model.model';
import { DetailedTicketDTO } from '../../core/models/dto/detailed-ticket.dto';
import { FormsModule } from '@angular/forms';
import { CheckFormInitDirective } from '../../../sb-modules/Frontend-form-field-module/common/directives/check-form-init.directive';
import { FocusDirective } from '../../../sb-tools/typescript/directives/focus.directive';

@Component({
    selector: 'app-hide-ticket-content',
    templateUrl: './hide-ticket-content.component.html',
    styleUrls: ['./hide-ticket-content.component.scss'],
    imports: [TranslateModule, FormsModule, CheckFormInitDirective, FocusDirective],
})
export class HideTicketContentComponent {
    @Input() ticket: DetailedTicketDTO;
    @Input() replyId: number;
    @Input() hidingText: string;

    isSaving = false;
    isWholeContentHidden = false;

    private unsubscriber = new Subject<void>();

    constructor(
        private rightPanelService: RightPanelService,
        private ticketService: TicketService,
        private notificationsService: NotificationsService,
        private translateService: TranslateService,
    ) {}

    closePanel(): void {
        this.rightPanelService.close();
    }

    save() {
        this.isSaving = true;
        const contentVisibilityModel: ContentVisibilityModel = {
            isWholeContentHidden: this.isWholeContentHidden,
            replyId: this.replyId,
            text: this.hidingText || '',
        };
        this.ticketService
            .hideContent(this.ticket.id, contentVisibilityModel)
            .pipe(
                takeUntil(this.unsubscriber),
                finalize(() => {
                    this.isSaving = false;
                }),
            )
            .subscribe((hideContent: HideContentPartResponseDTO) => {
                if (this.replyId) {
                    const reply = this.ticket.messageThread.find((item) => {
                        return item.id === this.replyId;
                    });
                    (reply as ThreadElementDTO).hasContentPartHiddenForClient =
                        hideContent.hasContentPartHiddenForClient;
                    (reply as ThreadElementDTO).isContentHiddenForClient = hideContent.isContentHiddenForClient;
                    (reply as ThreadElementDTO).message = hideContent.message;
                } else {
                    this.ticket.hasContentPartHiddenForClient = hideContent.hasContentPartHiddenForClient;
                    this.ticket.isContentHiddenForClient = hideContent.isContentHiddenForClient;
                    this.ticket.message = hideContent.message;
                }
                this.notificationsService.success(
                    this.translateService.instant('Success!'),
                    this.translateService.instant('The content was successfully hidden.'),
                );
                this.closePanel();
            });
    }
}
